//model
import { ATDLValidationRuleModel } from "./atdl-validation-rule.model";
// enum
import { ATDLNLogicOperator } from "../enums/atdl-logic-operator.enum";

export class ATDLValidationGroupModel {
  public logicOperatorText: string = null;
  public logicOperator: ATDLNLogicOperator = null;
  public logicGroups: Array<ATDLValidationGroupModel> = null;
  public rules: Array<ATDLValidationRuleModel> = null;

  constructor(logicOperator?: ATDLNLogicOperator) {
    this.logicOperator = logicOperator;
  }
}
